import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  private companiesUrl = 'assets/data/companies.json';

  constructor(private http: HttpClient) { }

  getCompanies(): Observable<any[]> {
    console.log('Loading companies from:', this.companiesUrl);
    return this.http.get<any[]>(this.companiesUrl).pipe(
      map(companies => {
        console.log('Companies loaded:', companies);
        return companies;
      }),
      catchError(this.handleError<any[]>('getCompanies', []))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}